var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/payment-icons/dci.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" width=\"22\" height=\"15\" viewBox=\"0 0 750 471\" version=\"1.1\" data-qa-dci-icon>\n\n    <title>\n        ";
output += runtime.suppressValue((lineno = 5, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["credit-card_diners",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n    </title>\n\n    <desc>\n        ";
output += runtime.suppressValue((lineno = 9, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["credit-card_diners-description",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n    </desc>\n\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n\n        <g id=\"diners\" sketch:type=\"MSLayerGroup\">\n\n            <rect id=\"rectangle\" fill=\"#0079BE\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"0\" width=\"750\" height=\"471\" rx=\"40\"></rect>\n\n            <path d=\"M584.93 237.95C584.93 138.53 501.95 69.81 411.04 69.85L332.8 69.85C240.79 69.81 165.07 138.55 165.07 237.95 165.07 328.88 240.79 403.59 332.8 403.15L411.04 403.15C501.95 403.59 584.93 328.86 584.93 237.95L584.93 237.95Z\" id=\"Shape-path\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n\n            <path d=\"M333.28 83.93C249.21 83.96 181.09 152.24 181.07 236.51 181.09 320.77 249.21 389.04 333.28 389.07 417.37 389.04 485.51 320.77 485.52 236.51 485.51 152.24 417.37 83.96 333.28 83.93L333.28 83.93Z\" id=\"Shape-path\" fill=\"#0079BE\" sketch:type=\"MSShapeGroup\"></path>\n\n            <path d=\"M237.07 236.1C237.15 194.92 262.81 159.8 299.01 145.85L299.01 326.33C262.81 312.38 237.14 277.28 237.07 236.1ZM368.07 326.37L368.07 145.85C404.27 159.77 429.98 194.9 430.05 236.1 429.98 277.32 404.27 312.43 368.07 326.37Z\" id=\"Path\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n\n        </g>\n\n    </g>\n\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/payment-icons/dci.j2"] , dependencies)